
import { generate, validate } from './helper/svg';

export default {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = generate('');
    return element.firstChild;
  },
  validate: validate
};
//# sourceMappingURL=focus-svg.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-svg.js
// module id = 205
// module chunks = 0 1